export const EXTERNAL_LINKS = {
  REFERRAL_PROGRAM_DETAILS: 'https://docs.optimex.com/referrals/optimex-referral-program',
  REGISTER_PARTNER_OR_KOL:
    'https://docs.google.com/forms/d/e/1FAIpQLSc6ZiDfFI4wnjL0tlbsdZnJPsqN9TvHNVoNuB-KRvjJ5wcs_Q/viewform',
  X: 'https://x.com/optimexfi',
  DISCORD: 'https://discord.gg/optimex',
}
